import { Types } from './types'

export const setAlert = (data) => ({
  type: Types.SET_ALERT,
  payload: data,
});

export const setDealPrice = (price) => ({
  type: Types.DEAL_PRICE,
  payload: price,
});

export const setStakeAmount = (amount) => ({
  type: Types.STAKE_AMOUNT,
  payload: amount,
});

export const setDealName = (name) => ({
  type: Types.DEAL_NAME,
  payload: name,
});

export const setDealDesc = (desc) => ({
  type: Types.DEAL_DESC,
  payload: desc,
});

export const setDealWebsiteUrl = (url) => ({
  type: Types.DEAL_WEBSITE_URL,
  payload: url,
});

export const setLeadInvestor = (addr) => ({
  type: Types.DEAL_LEAD_INVESTOR,
  payload: addr,
});

export const setDealCrypto = (crypto) => ({
  type: Types.DEAL_CRYPTO,
  payload: crypto,
});

export const setPresailAmount = (amount) => ({
  type: Types.DEAL_PRESAIL_AMOUNT,
  payload: amount,
});

export const setMaxsaleAmount = (amount) => ({
  type: Types.DEAL_MAXSALE_AMOUNT,
  payload: amount,
});

export const setMinsaleAmount = (amount) => ({
  type: Types.DEAL_MINSALE_AMOUNT,
  payload: amount,
});

export const setStartBonus = (bonus) => ({
  type: Types.DEAL_START_BONUS,
  payload: bonus,
});

export const setEndBonus = (bonus) => ({
  type: Types.DEAL_END_BONUS,
  payload: bonus,
});

export const setDealLogo = (file) => ({
  type: Types.DEAL_LOGO,
  payload: file,
});

export const setOfferPeriod = (period) => ({
  type: Types.DEAL_OFFER_PERIOD,
  payload: period,
});

export const setOfferTerms = (terms) => ({
  type: Types.DEAL_OFFER_TERMS,
  payload: terms,
});

export const setMinStakeAmount = (amount) => ({
  type: Types.DEAL_MIN_STAKE_AMOUNT,
  payload: amount,
});

export const setMaxStakeAmount = (amount) => ({
  type: Types.DEAL_MAX_STAKE_AMOUNT,
  payload: amount,
});